import { Typography, createFilterOptions } from '@mui/material';
import { Control } from 'react-hook-form';
import { AssessmentCard } from '../shared';
import { rules } from '../demographics/rules';
import { ControlledAutocomplete } from '../shared/controlled-autocomplete';
import { MedicationPharmacyFormValues } from './medication-pharmacy';

type PropTypes = {
  control: Control<MedicationPharmacyFormValues, any>;
};

const Medications = ({ control }: PropTypes) => (
  <AssessmentCard>
    <Typography component="h3" variant="h5">
      Please list any medications you are currently taking
    </Typography>
    <ControlledAutocomplete<MedicationPharmacyFormValues>
      name="medications"
      control={control}
      rules={rules.medications}
      options={[]}
      freeSolo
      multiple
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      filterOptions={(options, params) => {
        const filter = createFilterOptions<string>();
        const filtered = filter(options, params);
        if (params.inputValue !== '') filtered.push(params.inputValue);
        return filtered;
      }}
      label="Current Medications"
    />
  </AssessmentCard>
);

export default Medications;
